import { render, staticRenderFns } from "./PendingRegistrationDetails.vue?vue&type=template&id=b820fe40&scoped=true"
import script from "./PendingRegistrationDetails.vue?vue&type=script&lang=js"
export * from "./PendingRegistrationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b820fe40",
  null
  
)

export default component.exports